import { EditPage, EditPageTextField, EditPagePanel, EditPageSelect } from './../../../common/EditPage';
import { create, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const TeamsCreate = (props) => {
    const [data, setData] = useState({ name: '', company_id: '', branch_id: '' });
    const [metadata, setMetadata] = useState({ companies: [], branches: [] });
    const navigate = useNavigate();

    useEffect(() => {
        getOne('/admin/clients/teams/', 'new').then(response => {
            setMetadata(response.data.metadata);
        });
    }, []);

    const handleSave = () => {
        create('/admin/clients/teams', { data }).then(response => {
            toast.success('Team created successfully', {});
            navigate('/clients/teams');
        }).catch(error => {
            toast.error('Error creating team: ' + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate('/clients/teams');
    };

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    };

    return (
        <div>
            <ToastContainer />
            <EditPage handleSave={handleSave} handleCancel={handleCancel} title="Create Team">
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField label="Name" id="name" onChange={onChange} value={data.name} required={true} />
                    <EditPageSelect
                        nullable
                        label="Company"
                        id="company_id"
                        onChange={onChange}
                        value={data.company_id}
                        options={Object.fromEntries((metadata.companies || []).map(c => [c.id, c.name]))}
                        required={true}
                    />
                    <EditPageSelect
                        nullable
                        label="Branch"
                        id="branch_id"
                        onChange={onChange}
                        value={data.branch_id}
                        options={Object.fromEntries((metadata.branches || []).map(b => [b.id, b.name]))}
                        required={false}
                    />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default TeamsCreate; 